import { render } from "./CProviderFormItem.vue?vue&type=template&id=2f9200e8"
import script from "./CProviderFormItem.vue?vue&type=script&lang=js"
export * from "./CProviderFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__